// Generated by CoffeeScript 2.7.0
// ==============================================================================
// MODULES - COMPONENTS - DUMMY LINKS
// ==============================================================================
import $ from "jquery";

$(function() {
  window.searchDummyLinks = function() {
    return $('.JS--dummyLinks').each(function() {
      var $this;
      $this = $(this);
      return $this.on('click', function() {
        return window.location.href = $this.attr('data-href');
      });
    });
  };
  return window.searchDummyLinks();
});
